module.exports = __webpack_public_path__ + "img/modal-check.31fe4f7e.png";